/** The turquoise ramp of the "Notes" tab intro card, deep to bright. */
export const NOTES_TURQUOISE_STOPS = 'from-turquoise-deep via-step-rail-turquoise to-primary-400';
